export const addons = [
  { id: 'WEBINAR', name: 'Платформа для вебинаров и конференций' },
  // { id: 'KINESCOPE', name: 'Доп услуга kinescope' },
];
